import * as types from '../mutation-types';

const state = {
  connecting: false,
  connection: null,
  countryCode: '44',
  currentNumber: '',
  muted: false,
  offline: true,
  onPhone: false,
  settings: {
    selectedInputDevice: 'default',
    selectedOutputRingToneDevice: 'default',
    selectedOutputSpeakerDevice: 'default'
  }
};
const getters = {
  Twilio: state => state
};
const actions = {
  selectTwilioInputDevice({ commit }, selectedInputDevice) {
    commit(types.SELECT_TWILIO_INPUT_DEVICE, selectedInputDevice);
  },
  selectTwilioOutputSpeakerDevice({ commit }, selectedOutputSpeakerDevice) {
    commit(types.SELECT_TWILIO_OUTPUT_SPEAKER_DEVICE, selectedOutputSpeakerDevice);
  },
  selectTwilioOutputRingToneDevice({ commit }, selectedOutputRingToneDevice) {
    commit(types.SELECT_TWILIO_OUTPUT_RINGTONE_DEVICE, selectedOutputRingToneDevice);
  },
  setTwilioDeviceMute({ commit }, muteState) {
    commit(types.SET_TWILIO_DEVICE_MUTE, muteState);
  },
  setTwilioOnPhoneState({ commit }, onPhoneState) {
    commit(types.SET_TWILIO_ON_PHONE_STATE, onPhoneState);
  },
  setTwilioOfflineState({ commit }, offlineState) {
    commit(types.SET_TWILIO_OFFLINE_STATE, offlineState);
  },

  toggleTwilioCall({ commit, dispatch, state }) {
    if (!state.onPhone) {
      dispatch('setTwilioDeviceMute', false);
      dispatch('setTwilioOnPhoneState', true);
      const number = '+' + this.countryCode + this.currentNumber.replace(/\D/g, '');
      const connection = window.TwilioDevice.connect({
        number,
        record: true
      });
      commit(types.SET_TWILIO_CONNECTION, connection);
    } else {
      window.TwilioDevice.disconnectAll();
    }
  }
};
const mutations = {
  [types.SELECT_TWILIO_INPUT_DEVICE](state, device) {
    state.settings.selectedInputDevice = device;
    window.Twilio.device.audio.setInputDevice(device).catch(error => console.log(error));
  },
  [types.SELECT_TWILIO_OUTPUT_SPEAKER_DEVICE](state, device) {
    state.settings.selectedOutputSpeakerDevice = device;
    window.Twilio.device.audio.speakerDevices.set(device).catch(error => console.log(error));
  },
  [types.SELECT_TWILIO_OUTPUT_RINGTONE_DEVICE](state, device) {
    state.settings.selectedOutputSpeakerDevice = device;
    window.Twilio.device.audio.ringtoneDevices.set(device).catch(error => console.log(error));
  },
  [types.SET_TWILIO_DEVICE_MUTE](state, muteState) {
    state.muted = muteState;
    window.Twilio.device.activeConnection().mute(muteState);
  },
  [types.SET_TWILIO_ON_PHONE_STATE](state, onPhoneState) {
    state.onPhone = onPhoneState;
  },
  [types.SET_TWILIO_OFFLINE_STATE](state, offlineState) {
    state.offline = offlineState;
  },
  [types.SET_TWILIO_DEVICE](state, device) {
    window.Twilio.device = device;
  },
  [types.SET_TWILIO_CONNECTION](state, connection) {
    state.connection = connection;
  }
};

export default { state, actions, getters, mutations };
